export const enum RULE_TYPE {
  OPEN = 'open',
  CLOSE = 'close'
}

export interface INavigationEditorPick {
  label: string;
  url: string;
  picture: string;
  legend: string;
}

export interface INavigationItem {
  id: string;
  mnemonic: string;
  label: string;
  url: string;
  anchor: boolean;
  active?: boolean;
  editorPick?: INavigationEditorPick;
  children?: INavigationItem[];
}

export interface PageData {
  [key: string]: string;
}
/**
 * Exclusive OR operator
 * @param a
 * @param b
 */
export const XOR = function(a: boolean, b: boolean): boolean {
  return a ? !b : b;
};

/**
 * Validate rule parameters
 *
 * @param pageData
 * @param rule
 * @param ruleType
 * @param anchored
 */
export const isRuleValid = function(pageData: PageData, rule: object, ruleType: string, anchored: boolean): boolean {
  if (XOR(anchored, ruleType === RULE_TYPE.CLOSE)) {
    let result = true;
    Object.keys(rule).forEach(propertyName => {
      if (!pageData[propertyName] || pageData[propertyName] !== rule[propertyName]) {
        result = false;
      }
    });

    anchored = XOR(result, ruleType === RULE_TYPE.OPEN);
  }

  return anchored;
};

/**
 *
 * @param rule
 * @param pageData
 * @param anchored
 */
export const analyzeRule = function(rule: object, pageData: PageData, anchored: boolean): boolean {
  Object.keys(rule).forEach(ruleType => {
    if (rule[ruleType] === 'all') {
      anchored = ruleType === RULE_TYPE.CLOSE;
    } else {
      anchored = isRuleValid(pageData, rule[ruleType], ruleType, anchored);
    }
  });

  return anchored;
};

/**
 * Compute anchor of each item using current page parameters
 * If no rules, by default items are not anchored
 *
 * @param item
 * @param AnchorRules
 */
export const isItemAnchored = function(anchorRules: Array<object>, pageData: PageData): boolean {
  let anchored = false;
  if (anchorRules) {
    anchorRules.forEach(rule => {
      anchored = analyzeRule(rule, pageData, anchored);
    });
  }

  return anchored;
};

/**
 * Transform raw json data of an item to INavigationItem
 *
 * @param itemJson
 */
export const formatToNavigationItem = function(itemJson: JSON, isServer: boolean, pageData: PageData): INavigationItem {
  const item = {
    id: itemJson['id'],
    mnemonic: itemJson['mnemonic'],
    label: itemJson['localizedName'],
    url: itemJson['url']['seo'],
    children: []
  } as INavigationItem;

  item.anchor = isServer ? isItemAnchored(itemJson['url']['anchor'], pageData) : false;

  /**
   * Check if item has children
   */
  if (itemJson['content']) {
    item.children = Object.keys(itemJson['content']).map(childItemJson =>
      formatToNavigationItem(itemJson['content'][childItemJson], isServer, pageData)
    );
  }

  return item;
};
